import { CLEAR_STATUS } from 'store/ui/types'
import * as types from './types'

const initialState = {
  current: null,
  // Первый ответ service_partners#me получен (успех или ошибка): до него
  // главная показывает Loader, после — не возвращается к нему при повторных
  // запросах (business_apps#1486 §4.1).
  currentResolved: false,
  // Настройки пользователя после PATCH /users/me/settings. Хранятся отдельно
  // от current, чтобы смена тоггла не пересоздавала объект партнёра (от его
  // ссылки зависят эффекты анкеты) и работала, даже если me не ответил.
  userSettings: null,
  error: null,
  msg: null,
}

export default function partners(state = initialState, { type, payload }) {
  switch (type) {
    // userSettings не сбрасываем: это последнее, что вкладка сохранила PATCH-ем,
    // а ответ me мог быть прочитан до него (поздний me откатил бы тоггл).
    case types.FETCH_CURRENT_SUCCESS:
      return { ...state, current: payload.partner, currentResolved: true }
    case types.FETCH_CURRENT_FAILURE:
      return { ...state, currentResolved: true }
    case types.SET_USER_SETTINGS:
      return { ...state, userSettings: payload.settings }
    case types.CREATE_PARTNER_SUCCESS:
      return { ...state, msg: payload.msg }
    case types.CREATE_PARTNER_FAILURE:
      return { ...state, error: payload.error }

    case CLEAR_STATUS:
      return { ...state, error: null, msg: null }
    default:
      return state
  }
}
